/**
 * Pure-Layout-Entscheidung für die Dashboard-Bottom-Section (Aktivität +
 * Expiring-Shares). Ausgelagert als reine Funktion, damit die Degradations-
 * Logik ohne Page-Render unit-testbar ist (Pattern wie dashboard-recent-view.ts
 * / active-filters.ts).
 *
 * Hintergrund (P0 Daten-Sparsity, 2026-06-10): 3–5 interne User mit kleinem
 * Bestand → Aktivität und ablaufende Share-Links sind die meiste Zeit leer.
 * Standen hier vorher zwei volle Empty-State-Karten nebeneinander = viel toter
 * Raum auf der Landing. Jetzt:
 *   - beide leer  → 'none'           (Section wird gar nicht gerendert)
 *   - nur eine    → '*-only'         (die mit Content rendert full-width)
 *   - beide       → 'both'           (2-Spalten wie bisher)
 * Loading/Error bleiben davon unberührt — die zeigen weiter beide Spalten.
 */
export type BottomPanelLayout = 'none' | 'activity-only' | 'shares-only' | 'both';

export function bottomPanelLayout(
  activityCount: number,
  sharesCount: number,
): BottomPanelLayout {
  const hasActivity = activityCount > 0;
  const hasShares = sharesCount > 0;
  if (hasActivity && hasShares) return 'both';
  if (hasActivity) return 'activity-only';
  if (hasShares) return 'shares-only';
  return 'none';
}
